(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hic-image-carousel')) {
    customElements.define('hic-image-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.timer = null;
        this.paused = false;
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.slideViewport = this.querySelector('.hic-image-text-carousel__slides');
        this.gesture = null;
        this.onPrevious = () => this.show(this.index - 1);
        this.onNext = () => this.show(this.index + 1);
        this.onDots = (event) => {
          const dot = event.target.closest('[data-dot]');
          if (dot) this.show(this.dots.indexOf(dot));
        };
        this.onPointerDown = (event) => {
          if (!event.isPrimary || this.slides.length < 2 || (event.pointerType === 'mouse' && event.button !== 0)) return;
          if (event.pointerType === 'mouse') event.preventDefault();
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.slideViewport.setPointerCapture(event.pointerId);
          this.slideViewport.classList.add('is-dragging');
          this.stop();
        };
        this.onPointerUp = (event) => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          const dx = event.clientX - this.gesture.x;
          const dy = event.clientY - this.gesture.y;
          this.gesture = null;
          this.slideViewport.classList.remove('is-dragging');
          if (this.slideViewport.hasPointerCapture(event.pointerId)) this.slideViewport.releasePointerCapture(event.pointerId);
          if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.25) {
            this.show(this.index + (dx < 0 ? 1 : -1));
          } else {
            this.start();
          }
        };
        this.onPointerCancel = (event) => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture = null;
          this.slideViewport.classList.remove('is-dragging');
          this.start();
        };
        this.onPause = () => { this.paused = true; this.stop(); };
        this.onResume = () => { this.paused = false; this.start(); };
        this.onPointerEnter = (event) => { if (event.pointerType === 'mouse') this.onPause(); };
        this.onPointerLeave = (event) => { if (event.pointerType === 'mouse' && !this.gesture) this.onResume(); };
        this.onBlockSelect = (event) => {
          const slide = event.target.closest('[data-slide]');
          if (slide && this.contains(slide)) {
            this.stop();
            this.show(this.slides.indexOf(slide));
          }
        };
        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.addEventListener('click', this.onDots);
        this.slideViewport?.addEventListener('pointerdown', this.onPointerDown);
        this.slideViewport?.addEventListener('pointerup', this.onPointerUp);
        this.slideViewport?.addEventListener('pointercancel', this.onPointerCancel);
        this.addEventListener('pointerenter', this.onPointerEnter);
        this.addEventListener('pointerleave', this.onPointerLeave);
        this.addEventListener('focusin', this.onPause);
        this.addEventListener('focusout', this.onResume);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.show(0);
      }
      disconnectedCallback() {
        this.stop();
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.removeEventListener('click', this.onDots);
        this.slideViewport?.removeEventListener('pointerdown', this.onPointerDown);
        this.slideViewport?.removeEventListener('pointerup', this.onPointerUp);
        this.slideViewport?.removeEventListener('pointercancel', this.onPointerCancel);
        this.removeEventListener('pointerenter', this.onPointerEnter);
        this.removeEventListener('pointerleave', this.onPointerLeave);
        this.removeEventListener('focusin', this.onPause);
        this.removeEventListener('focusout', this.onResume);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      show(index) {
        if (this.slides.length === 0) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
        this.dots.forEach((dot, position) => {
          dot.setAttribute('aria-current', String(position === this.index));
        });
        this.start();
      }
      start() {
        this.stop();
        if (this.paused || this.slides.length < 2 || this.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 5000);
      }
      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  (function () {
    function sync(root) {
      var dots = root.querySelectorAll('.hic-image-text-carousel__dot');
      var texts = root.querySelectorAll('[data-text-slide]');
      if (!dots.length || texts.length < 2) return;
      function apply() {
        var active = 0;
        dots.forEach(function (d, i) { if (d.getAttribute('aria-current') === 'true') active = i; });
        texts.forEach(function (t, i) { if (i === active) { t.removeAttribute('hidden'); } else { t.setAttribute('hidden', ''); } });
      }
      var mo = new MutationObserver(apply);
      dots.forEach(function (d) { mo.observe(d, { attributes: true, attributeFilter: ['aria-current'] }); });
      apply();
    }
    function init() { document.querySelectorAll('.hic-image-text-carousel').forEach(sync); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
